import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";
import request from "@/utils/request";

Vue.use(VueRouter)


//静态路由
const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
  /*  {
        path: '/register',
        name: 'Register',
        component: () => import('../views/Register.vue')
    },*/
    {
        path: '/404',
        name: '404',
        component: () => import('../views/404.vue')
    },
    {
        path: '/websocket',
        name: 'websocket',
        component: () => import('../views/testWebsocket.vue')
    },
    {
        path: '/visitor',
        name: 'Visitor',
        component: () => import('../views/Visitor.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// 提供一个重置路由的方法
export const resetRouter = () => {
    router.matcher = new VueRouter({
        mode: 'history',
        base: process.env.BASE_URL,
        routes
    })
}

// 注意：刷新页面会导致页面路由重置
export const setRoutes = () => {


    /* request.get("/echarts/members").then(res => {

       console.log(res)
     })*/

    const storeMenus = localStorage.getItem("menus");
    if (storeMenus) {
        // 获取当前的路由对象名称数组
        const currentRouteNames = router.getRoutes().map(v => v.name)
        if (!currentRouteNames.includes('Manage')) {


            // 拼装动态路由
            const manageRoute = {
                path: '/',
                name: 'Manage',
                component: () => import('../views/Manage.vue'),
                redirect: "/home",
                children: [
                    {path: 'person', name: '个人信息', component: () => import('../views/Person.vue')},
                    {path: 'password', name: '修改密码', component: () => import('../views/Password.vue'),},
                  /*  {path: 'map', name: '电子地图', component: () => import('../views/Map.vue'),},*/
                    {path: 'map', name: '地图监控', component: () => import('../views/Map.vue'),},
                  /*  {path: 'show', name: '数据展示', component: () => import('../views/Show.vue'),}*/
                ]
            }
            const manageRoute2 = {
                path: '/show',
                name: 'show',
                component: () => import('../views/Show.vue')
            }

            const manageRoute3 = {
                path: '/show_',
                name: 'show_',
                component: () => import('../views/Show_.vue')
            }

            const menus = JSON.parse(storeMenus)
            menus.forEach(item => {
                if (item.path) {  // 当且仅当path不为空的时候才去设置路由
                    let itemMenu = {
                        path: item.path.replace("/", ""),
                        name: item.name,
                        component: () => import('../views/' + item.pagePath + '.vue')
                    }
                    manageRoute.children.push(itemMenu)
                } else if (item.children.length) {
                    item.children.forEach(item => {
                        if (item.path) {
                            let itemMenu = {
                                path: item.path.replace("/", ""),
                                name: item.name,
                                component: () => import('../views/' + item.pagePath + '.vue')
                            }
                            manageRoute.children.push(itemMenu)
                        }
                    })
                }
            })
            // 动态添加到现在的路由对象中去
            router.addRoute(manageRoute)
            router.addRoute(manageRoute2)
            router.addRoute(manageRoute3)


        }

    }
}

// 重置我就再set一次路由
setRoutes()


//路由守卫
router.beforeEach((to, from, next) => {
    //window.document.title = "EBT_IOT"
    localStorage.setItem("currentPathName", to.name)  // 设置当前的路由名称
    localStorage.setItem("currentChildrenPathName", to.name)  // 设置当前的路由名称
    store.commit("setPath")

    // 未找到路由的情况
    if (!to.matched.length) {
        const storeMenus = localStorage.getItem("menus")
        if (storeMenus) {
            next("/404")
        } else {
            // 跳回登录页面
            next("/login")
        }
    }
    // 其他的情况都放行
    next()

})

export default router
